import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import { useTranslate } from 'src/localization/Trns'

interface ActiveUntilTooltipProps {
  openLeft: boolean
  hideMdUp?: boolean
  hideSmDown?: boolean
}

const InvoiceAmountTooltip: React.FC<ActiveUntilTooltipProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  return (
    <Tooltip
      openLeft={props.openLeft}
      hideMdUp={props.hideMdUp}
      hideSmDown={props.hideSmDown}
    >
      <p>{translate('Enter the total amount due as shown on the invoice')}</p>
    </Tooltip>
  )
}

export default InvoiceAmountTooltip
